/**
 * Session.jsx
 * Tatalli Cloud — Oturum Koruma Bileşeni
 * Oturum yoksa /portal/login'e yönlendirir.
 * basePath="/portal" → Customers rolü gerekli
 * basePath="/ca"     → CA rolü gerekli
 */

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";

const ROL_HARITASI = {
  '/portal': 'Customers',
  '/ca':     'Administrators',
};

const Session = ({ children, basePath }) => {
  const navigate = useNavigate();
  const [girisYapildi, setGirisYapildi] = useState(false);

  useEffect(() => {
    const raw = sessionStorage.getItem('currentSession');
    if (!raw) {
      setTimeout(() => { window.location.href = '/portal/login'; navigate('/portal/login'); }, 200);
      return;
    }

    try {
      const oturum = JSON.parse(raw);
      if (!oturum?.access_token) {
        setTimeout(() => { window.location.href = '/portal/login'; navigate('/portal/login'); }, 200);
        return;
      }

      try {
        const decoded = jwtDecode(oturum?.access_token);

        const gruplar = decoded.resource_access?.['api-gateway-client']?.roles || [];
        const gerekliRol = ROL_HARITASI[basePath];
        const yetkili = Array.isArray(gruplar) && gruplar.some(g => g === gerekliRol);
        if (!yetkili) {
          setTimeout(() => { window.location.href = '/portal/logout'; navigate('/portal/logout'); }, 200);
          return;
        }

        setGirisYapildi(true);

      } catch (error) {
        console.error("Token decode edilemedi:", error);
      }

    } catch {
      setTimeout(() => { window.location.href = '/portal/login'; navigate('/portal/login'); }, 200);
    }
  }, [navigate, basePath]);

  if (!girisYapildi) return null;

  return <React.Fragment>{children}</React.Fragment>;
};

export default Session;